var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_43802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18 20.7506C7.38398 20.7506 8.36 19.7746 8.36 18.5706C8.36 17.3666 7.38398 16.3906 6.18 16.3906C4.97602 16.3906 4 17.3666 4 18.5706C4 19.7746 4.97602 20.7506 6.18 20.7506Z",
    fill: "#F47738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59 10.9798C4.75 10.8398 4 11.5298 4 12.3798C4 13.0898 4.53 13.6598 5.23 13.7798C8.15 14.2898 10.45 16.5998 10.97 19.5198C11.09 20.2198 11.66 20.7498 12.37 20.7498C13.22 20.7498 13.91 19.9998 13.78 19.1598C13.1 14.9598 9.79 11.6498 5.59 10.9798ZM5.56 5.26984C4.73 5.17984 4 5.84984 4 6.67984C4 7.40984 4.55 8.00984 5.27 8.07984C11.28 8.67984 16.06 13.4598 16.66 19.4698C16.73 20.1998 17.33 20.7498 18.06 20.7498C18.9 20.7498 19.56 20.0198 19.48 19.1898C18.75 11.8498 12.91 5.99984 5.56 5.26984Z",
    fill: "#F47738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_43802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRss);
export default __webpack_public_path__ + "static/media/icon-rss.2dcb7aa8ae6bcb789bf9d41eaabbeea0.svg";
export { ForwardRef as ReactComponent };